import React, { useState } from 'react';
import Module1Card from '../Module1Card/Module1Card';
import Module2Card from '../Module2Card/Module2Card';
import Module3Card from '../Module3Card/Module3Card';
import Modal from '../Modal/Modal';
import ProctorBypass from '../ProctorBypass/ProctorBypass';
import VMBypass from '../VMBypass/VMBypass';
import ServerStreaming from '../ServerStreaming/ServerStreaming';
import './Modules.css';

const Modules = () => {
  const [isModal1Open, setIsModal1Open] = useState(false);
  const [isModal2Open, setIsModal2Open] = useState(false);
  const [isModal3Open, setIsModal3Open] = useState(false);

  const openModal1 = () => {
    setIsModal1Open(true);
    const scrollIndicator = document.querySelector('.scroll-indicator');
    if (scrollIndicator) {
      scrollIndicator.style.display = 'none';
    }
  };
  
  const closeModal1 = () => {
    setIsModal1Open(false);
    const scrollIndicator = document.querySelector('.scroll-indicator');
    if (scrollIndicator) {
      scrollIndicator.style.display = 'flex';
    }
  };

  const openModal2 = () => {
    setIsModal2Open(true);
    const scrollIndicator = document.querySelector('.scroll-indicator');
    if (scrollIndicator) {
      scrollIndicator.style.display = 'none';
    }
  };
  
  const closeModal2 = () => {
    setIsModal2Open(false);
    const scrollIndicator = document.querySelector('.scroll-indicator');
    if (scrollIndicator) {
      scrollIndicator.style.display = 'flex';
    }
  };

  const openModal3 = () => {
    setIsModal3Open(true);
    const scrollIndicator = document.querySelector('.scroll-indicator');
    if (scrollIndicator) {
      scrollIndicator.style.display = 'none';
    }
  };
  
  const closeModal3 = () => {
    setIsModal3Open(false);
    const scrollIndicator = document.querySelector('.scroll-indicator');
    if (scrollIndicator) {
      scrollIndicator.style.display = 'flex';
    }
  };

  return (
    <>
      {/* Module 1 Section */}
      <section className="module-1-section" id="module-1">
        <div className="module-container">
          <div className="module-header">
            <h2 className="module-title">Module 1</h2>
            <p className="module-subtitle">Browser-Based Protection</p>
          </div>

          <Module1Card 
            onClick={openModal1}
            particlesCount={300}
            particlesOpacity={0.6}
            particlesSway={0.5}
          />
        </div>
      </section>

      {/* Module 2 Section */}
      <section className="module-2-section" id="module-2">
        <div className="module-container">
          <div className="module-header">
            <h2 className="module-title">Module 2</h2>
            <p className="module-subtitle">VM-Based Protection</p>
          </div>

          <Module2Card 
            onClick={openModal2}
            particlesCount={400}
            particlesOpacity={0.7}
            particlesSway={0.6}
          />
        </div>
      </section>

      {/* Module 3 Section */}
      <section className="module-3-section" id="module-3">
        <div className="module-container">
          <div className="module-header">
            <h2 className="module-title">Module 3</h2>
            <p className="module-subtitle">Server Streaming Solution</p>
          </div>

          <Module3Card 
            onClick={openModal3}
            particlesCount={350}
            particlesOpacity={0.65}
            particlesSway={0.55}
          />
        </div>
      </section>

      <Modal isOpen={isModal1Open} onClose={closeModal1} theme="cyan">
        <ProctorBypass />
      </Modal>

      <Modal isOpen={isModal2Open} onClose={closeModal2}>
        <VMBypass />
      </Modal>

      <Modal isOpen={isModal3Open} onClose={closeModal3}>
        <ServerStreaming />
      </Modal>
    </>
  );
};

export default Modules;
